import { Component, OnInit } from '@angular/core';
import { ContextualMenuService } from '../../services/contextual-menu.service';
import { CompaniesService } from '../../services/companies.service';
import { Sections, Steps } from '../../constants';
import { CompanyUserService } from '../../services/company-user.service';
import constants from 'src/app/shared/constants';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReceiversService } from 'src/app/shared/services/receivers.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  public steps = Steps;
  public sections = Sections;
  subscription;
  featureFlags = constants.featureFlags;

  constructor(
    public authService: AuthService,
    public companiesService: CompaniesService,
    public contextualMenuService: ContextualMenuService,
    private readonly companyUserService: CompanyUserService,
    private readonly translateService: TranslateService,
    private readonly snackBar: MatSnackBar,
    public receiversService: ReceiversService
  ) {
    this.companiesService.onReset();
  }

  ngOnInit(): void {
    this.onGetCompanies();
    this.getReceiverServers();

    this.subscription = this.companiesService.refetchCompanies$.subscribe((value) => {
      if (value) this.onGetCompanies();
    });
  }

  onGetCompanies() {
    this.companiesService.loading = true;

    if (this.companyUserService.adminHasChosenCompany()) {
      return this.fetchCompany(this.companyUserService.getCompanyIdChosenByAdmin());
    }

    this.fetchCompanies();
  }

  fetchCompany(companyId: string) {
    this.companyUserService.getCompany(companyId).subscribe({
      next: (res: any) => {
        this.companiesService.loading = false;
        this.companiesService.setCompanies([res.company]);
      },
      error: (error) => {
        this.companiesService.loading = false;
        this.companiesService.setCompanies([error.error.company]);

        if (error?.status === 401) {
          this.snackBar.open(
            this.translateService.instant('Shared.SessionExpired'),
            this.translateService.instant('Shared.Close'),

            { duration: constants.snackBarErrorDuration }
          );
          this.authService.logout();
        } else {
          this.snackBar.open(
            this.translateService.instant('Settings.Error.NoGetCompany'),
            this.translateService.instant('Shared.Close'),

            { duration: constants.snackBarErrorDuration }
          );
        }
      },
    });
  }

  fetchCompanies() {
    this.companyUserService.getCompanies().subscribe({
      next: (res: any) => {
        this.companiesService.loading = false;
        this.companiesService.setCompanies(res.company ?? []);
      },
      error: (error) => {
        this.companiesService.loading = false;
        this.companiesService.setCompanies(error.error.company ?? []);

        if (error?.status === 401) {
          this.snackBar.open(
            this.translateService.instant('Shared.SessionExpired'),
            this.translateService.instant('Shared.Close'),

            { duration: constants.snackBarErrorDuration }
          );
          this.authService.logout();
        } else {
          this.snackBar.open(
            this.translateService.instant('Settings.Error.NoGetCompany'),
            this.translateService.instant('Shared.Close'),

            { duration: constants.snackBarErrorDuration }
          );
        }
      },
    });
  }

  getReceiverServers() {
    this.companyUserService.getReceiverServers().subscribe({
      next: (res: any) => {
        this.receiversService.setReceiverServers(res.receiverServers);
      },
      error: (error) => {
        this.receiversService.setReceiverServers([]);

        if (error?.status === 401) {
          this.snackBar.open(
            this.translateService.instant('Shared.SessionExpired'),
            this.translateService.instant('Shared.Close'),

            { duration: constants.snackBarErrorDuration }
          );
          this.authService.logout();
        } else {
          this.snackBar.open(
            this.translateService.instant('Settings.Error.ReceiverServers'),
            this.translateService.instant('Shared.Close'),

            { duration: constants.snackBarErrorDuration }
          );
        }
      },
    });
  }

  newCompany() {
    if (this.authService.shouldBlockViewer()) return;
    this.companiesService.onCreate();
  }

  checkSection(section) {
    return section === this.companiesService.currentSection;
  }

  onClickOut(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.companiesService.setBackToMainEvent(true);
    }
  }
}
